import * as yup from 'yup'

import { isValidCnpj, isValidCpf } from '../../util/documentValidator'
import { documentTypes } from '../../util/enums'
import { getMessage } from '../../util/IntlMessages'
import { getPasswordErrorMessage } from '../../util/passwordValidation'

export const UpdateFormValidations = (isAdmin) =>
  yup.object().shape({
    name: yup
      .string()
      .matches(/[a-zA-Z]+/g, 'Preencha um nome válido')
      .max(60)
      .typeError('must be string')
      .nullable(),
    phoneNumber: yup.string().max(20).typeError('must be string').nullable(),
    emailAddress: yup.string().max(60).typeError('must be string').email(getMessage('isInvalidEmail')).nullable(),
    dummy: yup.string(), // Used to organization dynamic validations
    organizations: yup
      .array()
      .of(yup.number())
      .when('dummy', {
        is: () => isAdmin,
        then: (schema) => schema.min(1).nullable(),
        otherwise: (schema) => schema.nullable()
      }),
    documentNumber: yup
      .string()
      .max(20)
      .nullable()
      .when('documentTypeId', (documentTypeId, schema) => {
        if (documentTypeId === documentTypes.CPF) {
          return schema.test('documentNumber', getMessage('cpfInvalid'), (value) => !value || isValidCpf(value))
        }
        if (documentTypeId === documentTypes.CNPJ) {
          return schema.test('documentNumber', getMessage('cnpjInvalid'), (value) => !value || isValidCnpj(value))
        }
        return schema
      }),
    documentTypeId: yup.string().max(20).nullable(),
    addressDescription: yup.string().max(60).typeError('must be string').nullable(),
    addressNumber: yup.string().max(10).typeError('must be string').nullable(),
    addressComplement: yup.string().max(60).typeError('must be string').nullable(),
    neighborhood: yup.string().max(60).typeError('must be string').nullable(),
    zipCode: yup.string().max(10).typeError('must be string').nullable(),
    memberTypeId: yup
      .number()
      .typeError('must be a valid id')
      .required(getMessage('isRequired', getMessage('memberTypes'))),
    regions: yup.array().of(yup.number()).min(1, getMessage('selectTheRegion')).required(getMessage('selectTheRegion')),
    profileId: yup
      .string()
      .nullable()
      .when('allowToLogin', (allowToLogin, schema) => {
        if (allowToLogin) {
          return schema.required(getMessage('isRequired', getMessage('profile')))
        }

        return schema
      }),
    password: yup.string().nullable(),
    confirmPassword: yup.string().nullable()
  })

export const CreateFormValidations = (isAdmin) =>
  yup.object().shape({
    phoneNumber: yup.string().max(20).typeError('must be string').nullable(),
    emailAddress: yup
      .string()
      .max(60)
      .typeError('must be string')
      .email(getMessage('isInvalidEmail'))
      .required(getMessage('isRequired', getMessage('emailAddress')))
      .nullable(),
    dummy: yup.string(), // Used to organization dynamic validations
    organizations: yup
      .array()
      .of(yup.number())
      .when('dummy', {
        is: () => isAdmin,
        then: (schema) =>
          schema
            .min(1, getMessage('isRequired', getMessage('organization')))
            .required(getMessage('isRequired', getMessage('organization'))),
        otherwise: (schema) => schema.nullable()
      }),
    documentNumber: yup
      .string()
      .max(20)
      .required(getMessage('isRequired', getMessage('documentNumber')))
      .nullable()
      .when('documentTypeId', (documentTypeId, schema) => {
        switch (documentTypeId) {
          case documentTypes.CPF:
            return schema.test('documentNumber', getMessage('cpfInvalid'), (value) => isValidCpf(value))
          case documentTypes.CNPJ:
            return schema.test('documentNumber', getMessage('cnpjInvalid'), (value) => isValidCnpj(value))
          default:
            return schema
        }
      }),
    documentTypeId: yup
      .string(getMessage('isRequired', getMessage('documentType')))
      .max(20)
      .required(getMessage('isRequired', getMessage('documentType')))
      .nullable(),
    addressDescription: yup.string().max(60).typeError('must be string').nullable(),
    name: yup
      .string()
      .matches(/[a-zA-Z]+/g, 'Preencha um nome válido')
      .max(60)
      .typeError('must be string')
      .required(getMessage('isRequired', getMessage('memberName'))),
    addressNumber: yup.string().max(10).typeError('must be string').nullable(),
    addressComplement: yup.string().max(60).typeError('must be string').nullable(),
    neighborhood: yup.string().max(60).typeError('must be string').nullable(),
    zipCode: yup.string().max(10).typeError('must be string').nullable(),
    memberTypeId: yup
      .number()
      .typeError('must be a valid id')
      .required(getMessage('isRequired', getMessage('memberTypes')))
      .nullable(),
    regions: yup.array().of(yup.number()).min(1, getMessage('selectTheRegion')).required(getMessage('selectTheRegion')),
    profileId: yup
      .string()
      .nullable()
      .when('allowToLogin', (allowToLogin, schema) => {
        if (allowToLogin) {
          return schema.required(getMessage('isRequired', getMessage('profile')))
        }

        return schema.nullable()
      }),
    password: yup
      .string()
      .nullable()
      .when('allowToLogin', (allowToLogin, schema) => {
        if (allowToLogin) {
          return schema
            .required(getMessage('isRequired', 'Senha'))
            .test('password', 'Erro de validação', function (value) {
              if (!value) return true // Deixa o required lidar com isso
              const errorMessage = getPasswordErrorMessage(value)
              if (errorMessage) {
                return this.createError({ message: errorMessage })
              }
              return true
            })
        }

        return schema.nullable()
      }),
    confirmPassword: yup
      .string()
      .nullable()
      .when('allowToLogin', (allowToLogin, schema) => {
        if (allowToLogin) {
          return schema
            .required(getMessage('isRequired', 'Confirmação de Senha'))
            .oneOf([yup.ref('password'), null], 'As senhas devem ser iguais')
        }

        return schema.nullable()
      })
  })
